import React from 'react';
import { MessageDialog } from 'components/Dialog/Dialog';
import { get } from 'lib/comms';

export default class EditBrowseTrust extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showMessage: null,
            localFileUrl: null,
            localFileName: null,
        };
    }

    componentWillUnmount() {
        if (this.state.localFileUrl) {
            URL.revokeObjectURL(this.state.localFileUrl);
        }
    }

    fileChange = (e) => {
        const acceptedFile = e.target.files;

        if (acceptedFile.length > 0) {
            const file = acceptedFile[0];
            const { size } = file;

            if (size > 10000000) {
                e.target.value = '';

                return this.setState({
                    showMessage: {
                        title: 'Message',
                        message: 'You can upload maximum of 10MB file',
                    },
                });
            }

            if (this.state.localFileUrl) {
                URL.revokeObjectURL(this.state.localFileUrl);
            }

            const localFileUrl = URL.createObjectURL(file);

            this.setState({
                localFileUrl,
                localFileName: file.name,
            });

            this.props.onFileChange(file);

            e.target.value = '';
        }
    };

    getDownloadUrl = () => {
        return this.state.localFileUrl || this.props.downloadUrl || this.props.fileUrl || null;
    };

    getDownloadFileName = () => {
        return this.state.localFileName || this.props.fileName || 'download';
    };

    downloadFile = async () => {
        const downloadUrl = this.getDownloadUrl();

        if (!downloadUrl) return;

        if (this.state.localFileUrl && downloadUrl === this.state.localFileUrl) {
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = this.getDownloadFileName();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
        }

        const resp = await get(downloadUrl, null, true);

        if (resp && resp.success && resp.file_uri) {
            window.open(resp.file_uri, '_blank');
            return;
        }

        this.setState({
            showMessage: {
                title: 'Download File',
                message: resp && resp.message ? resp.message : 'Could not download file.',
            },
        });
    };

    render() {
        const classNameOuter = `${
            this.props.className || ''
        } mdc-text-field edittext-outer mt-3 mb-3 mdc-text-field--outlined ${
            this.props.editing ? 'editing' : 'notediting'
        }`;

        const classNameButton = `editBrowse-button ${this.props.editing ? 'editing' : 'notediting'}`;

        const {
            fileName,
            acceptFileTypes = '.json,.plist,.mobileprovision,.p12,application/json,application/xml,text/xml,application/octet-stream,application/x-pkcs12',
        } = this.props;

        const downloadUrl = this.getDownloadUrl();
        const displayFileName = this.state.localFileName || fileName || '';

        return (
            <div className={classNameOuter} style={{ marginLeft: this.props.marginLeft || '0' }}>
                <div
                    className="editBrowse-inner"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        gap: '10px',
                    }}
                >
                    <label className={classNameButton}>
                        Browse
                        {this.props.editing ? (
                            <input type="file" onChange={this.fileChange} accept={acceptFileTypes} />
                        ) : null}
                    </label>

                    <div
                        className="editBrowse-fileName-container"
                        style={{
                            flex: 1,
                            minWidth: 0,
                        }}
                    >
                        <input
                            className="editBrowse-fileName-title"
                            style={{
                                opacity: this.props.editing ? 1 : 0.37,
                                width: '100%',
                            }}
                            type="text"
                            value={displayFileName}
                            readOnly
                        />
                    </div>

                    {downloadUrl ? (
                        <button
                            type="button"
                            className="editBrowse-button editing"
                            style={{
                                marginLeft: 'auto',
                                whiteSpace: 'nowrap',
                                textDecoration: 'none',
                                border: 'none',
                                marginRight: '10px',
                            }}
                            onClick={this.downloadFile}
                        >
                            Download
                        </button>
                    ) : null}
                </div>

                <div className="mdc-notched-outline mdc-notched-outline--upgraded mdc-notched-outline--notched">
                    <div className="mdc-notched-outline__leading"></div>
                    <div className="mdc-notched-outline__trailing"></div>
                </div>

                {this.state.showMessage ? (
                    <MessageDialog
                        message={this.state.showMessage.message}
                        title={this.state.showMessage.title}
                        onClose={() => this.setState({ showMessage: null })}
                    />
                ) : null}
            </div>
        );
    }
}
